module.exports = {"platforms":[{"type":"FiniteImmobilePlatform","x":256,"y":384,"width":192,"height":32,"display":{"assetName":"grass"},"attributes":{"spiked":true}},{"type":"FiniteImmobilePlatform","x":32,"y":384,"width":192,"height":32,"display":{"assetName":"grass"}},{"type":"InfiniteRectangularPlatform","x":800,"y":500,"width":-256,"height":256,"direction":"horizontal","display":{"assetName":"test"}}],"goal":{"x":700,"y":500},"player":{"x":160,"y":180}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/json-loader!./levels/test1.json
// module id = 25
// module chunks = 0